import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "panel alert-settings" }
const _hoisted_2 = { class: "alert-settings-heading" }
const _hoisted_3 = {
  key: 0,
  class: "notice"
}
const _hoisted_4 = { class: "wide" }
const _hoisted_5 = ["value"]
const _hoisted_6 = ["value"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = ["value"]
const _hoisted_11 = { key: 3 }
const _hoisted_12 = ["value"]
const _hoisted_13 = { key: 4 }
const _hoisted_14 = ["value"]
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "alert-rule-list" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 0,
  class: "empty-alerts"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[14] || (_cache[14] = _createElementVNode("div", null, [
        _createElementVNode("h2", null, "Алерты метрик"),
        _createElementVNode("p", null, "Отдельные уведомления о срабатывании и возврате метрики в норму.")
      ], -1 /* CACHED */)),
      _createElementVNode("span", null, _toDisplayString($setup.rules.length) + " правил", 1 /* TEXT */)
    ]),
    ($setup.message)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString($setup.message), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    _createElementVNode("form", {
      class: "alert-rule-form",
      onSubmit: _withModifiers($setup.createRule, ["prevent"])
    }, [
      _createElementVNode("label", _hoisted_4, [
        _cache[15] || (_cache[15] = _createTextVNode("Название", -1 /* CACHED */)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.form.name) = $event)),
          placeholder: "Например, падение FTD по GE",
          required: ""
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, $setup.form.name]
        ])
      ]),
      _createElementVNode("label", null, [
        _cache[16] || (_cache[16] = _createTextVNode("Получатель", -1 /* CACHED */)),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.form.user_id) = $event)),
          required: ""
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.baseOptions.users, (user) => {
            return (_openBlock(), _createElementBlock("option", {
              key: user.id,
              value: user.id
            }, _toDisplayString(user.name) + _toDisplayString(user.telegram_configured ? "" : " · нет chat ID"), 9 /* TEXT, PROPS */, _hoisted_5))
          }), 128 /* KEYED_FRAGMENT */))
        ], 512 /* NEED_PATCH */), [
          [_vModelSelect, $setup.form.user_id]
        ])
      ]),
      _createElementVNode("label", null, [
        _cache[17] || (_cache[17] = _createTextVNode("Интеграция", -1 /* CACHED */)),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($setup.form.integration_connection_id) = $event)),
          required: ""
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.baseOptions.connections, (item) => {
            return (_openBlock(), _createElementBlock("option", {
              key: item.id,
              value: item.id
            }, _toDisplayString(item.name) + _toDisplayString(item.active ? "" : " · выключена"), 9 /* TEXT, PROPS */, _hoisted_6))
          }), 128 /* KEYED_FRAGMENT */))
        ], 512 /* NEED_PATCH */), [
          [_vModelSelect, $setup.form.integration_connection_id]
        ])
      ]),
      _createElementVNode("label", null, [
        _cache[19] || (_cache[19] = _createTextVNode("Метрика", -1 /* CACHED */)),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($setup.form.metric) = $event))
        }, [...(_cache[18] || (_cache[18] = [
          _createElementVNode("option", { value: "registrations_count" }, "Регистрации", -1 /* CACHED */),
          _createElementVNode("option", { value: "first_deposits_count" }, "Первые депозиты", -1 /* CACHED */)
        ]))], 512 /* NEED_PATCH */), [
          [_vModelSelect, $setup.form.metric]
        ])
      ]),
      _createElementVNode("label", null, [
        _cache[21] || (_cache[21] = _createTextVNode("Период", -1 /* CACHED */)),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($setup.form.period) = $event))
        }, [...(_cache[20] || (_cache[20] = [
          _createElementVNode("option", { value: "12_hours" }, "12 часов", -1 /* CACHED */),
          _createElementVNode("option", { value: "1_day" }, "Сутки", -1 /* CACHED */),
          _createElementVNode("option", { value: "3_days" }, "3 дня", -1 /* CACHED */),
          _createElementVNode("option", { value: "7_days" }, "7 дней", -1 /* CACHED */)
        ]))], 512 /* NEED_PATCH */), [
          [_vModelSelect, $setup.form.period]
        ])
      ]),
      _createElementVNode("label", null, [
        _cache[23] || (_cache[23] = _createTextVNode("Сравнение", -1 /* CACHED */)),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($setup.form.comparison_type) = $event))
        }, [...(_cache[22] || (_cache[22] = [
          _createElementVNode("option", { value: "previous_period" }, "С предыдущим периодом", -1 /* CACHED */),
          _createElementVNode("option", { value: "fixed_threshold" }, "С фиксированным порогом", -1 /* CACHED */)
        ]))], 512 /* NEED_PATCH */), [
          [_vModelSelect, $setup.form.comparison_type]
        ])
      ]),
      _createElementVNode("label", null, [
        _cache[25] || (_cache[25] = _createTextVNode("Условие", -1 /* CACHED */)),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (($setup.form.operator) = $event))
        }, [...(_cache[24] || (_cache[24] = [
          _createElementVNode("option", { value: "greater_than" }, "Стало больше", -1 /* CACHED */),
          _createElementVNode("option", { value: "less_than" }, "Стало меньше", -1 /* CACHED */)
        ]))], 512 /* NEED_PATCH */), [
          [_vModelSelect, $setup.form.operator]
        ])
      ]),
      ($setup.form.comparison_type === 'previous_period')
        ? (_openBlock(), _createElementBlock("label", _hoisted_7, [
            _cache[26] || (_cache[26] = _createTextVNode("Изменение, %", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (($setup.form.change_percent) = $event)),
              min: "0",
              step: "1",
              type: "number",
              required: ""
            }, null, 512 /* NEED_PATCH */), [
              [
                _vModelText,
                $setup.form.change_percent,
                void 0,
                { number: true }
              ]
            ])
          ]))
        : (_openBlock(), _createElementBlock("label", _hoisted_8, [
            _cache[27] || (_cache[27] = _createTextVNode("Порог", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => (($setup.form.threshold) = $event)),
              min: "0",
              step: "1",
              type: "number",
              required: ""
            }, null, 512 /* NEED_PATCH */), [
              [
                _vModelText,
                $setup.form.threshold,
                void 0,
                { number: true }
              ]
            ])
          ])),
      _createElementVNode("label", null, [
        _cache[29] || (_cache[29] = _createTextVNode("Уровень", -1 /* CACHED */)),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => (($setup.form.scope_level) = $event))
        }, [...(_cache[28] || (_cache[28] = [
          _createElementVNode("option", { value: "integration" }, "Интеграция", -1 /* CACHED */),
          _createElementVNode("option", { value: "partner" }, "+ партнёр", -1 /* CACHED */),
          _createElementVNode("option", { value: "brand" }, "+ бренд", -1 /* CACHED */),
          _createElementVNode("option", { value: "campaign" }, "+ кампания", -1 /* CACHED */)
        ]))], 512 /* NEED_PATCH */), [
          [_vModelSelect, $setup.form.scope_level]
        ])
      ]),
      ($setup.needsPartner)
        ? (_openBlock(), _createElementBlock("label", _hoisted_9, [
            _cache[31] || (_cache[31] = _createTextVNode("Партнёр", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => (($setup.form.partner_external_id) = $event)),
              required: ""
            }, [
              _cache[30] || (_cache[30] = _createElementVNode("option", {
                value: "",
                disabled: ""
              }, "Выберите партнёра", -1 /* CACHED */)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.dimensions.partners, (item) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: item.id,
                  value: item.id
                }, _toDisplayString(item.name) + " · #" + _toDisplayString(item.id), 9 /* TEXT, PROPS */, _hoisted_10))
              }), 128 /* KEYED_FRAGMENT */))
            ], 512 /* NEED_PATCH */), [
              [_vModelSelect, $setup.form.partner_external_id]
            ])
          ]))
        : _createCommentVNode("v-if", true),
      ($setup.needsBrand)
        ? (_openBlock(), _createElementBlock("label", _hoisted_11, [
            _cache[33] || (_cache[33] = _createTextVNode("Бренд", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => (($setup.form.brand_external_id) = $event)),
              required: ""
            }, [
              _cache[32] || (_cache[32] = _createElementVNode("option", {
                value: "",
                disabled: ""
              }, "Выберите бренд", -1 /* CACHED */)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.dimensions.brands, (id) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: id,
                  value: id
                }, "#" + _toDisplayString(id), 9 /* TEXT, PROPS */, _hoisted_12))
              }), 128 /* KEYED_FRAGMENT */))
            ], 512 /* NEED_PATCH */), [
              [_vModelSelect, $setup.form.brand_external_id]
            ])
          ]))
        : _createCommentVNode("v-if", true),
      ($setup.needsCampaign)
        ? (_openBlock(), _createElementBlock("label", _hoisted_13, [
            _cache[35] || (_cache[35] = _createTextVNode("Кампания", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => (($setup.form.campaign_external_id) = $event)),
              required: ""
            }, [
              _cache[34] || (_cache[34] = _createElementVNode("option", {
                value: "",
                disabled: ""
              }, "Выберите кампанию", -1 /* CACHED */)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.dimensions.campaigns, (id) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: id,
                  value: id
                }, "#" + _toDisplayString(id), 9 /* TEXT, PROPS */, _hoisted_14))
              }), 128 /* KEYED_FRAGMENT */))
            ], 512 /* NEED_PATCH */), [
              [_vModelSelect, $setup.form.campaign_external_id]
            ])
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("label", null, [
        _cache[37] || (_cache[37] = _createTextVNode("GEO", -1 /* CACHED */)),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => (($setup.form.country) = $event))
        }, [
          _cache[36] || (_cache[36] = _createElementVNode("option", { value: "" }, "Все GEO отдельно", -1 /* CACHED */)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.dimensions.countries, (country) => {
            return (_openBlock(), _createElementBlock("option", {
              key: country,
              value: country
            }, _toDisplayString(country), 9 /* TEXT, PROPS */, _hoisted_15))
          }), 128 /* KEYED_FRAGMENT */))
        ], 512 /* NEED_PATCH */), [
          [_vModelSelect, $setup.form.country]
        ])
      ]),
      _cache[38] || (_cache[38] = _createElementVNode("button", { class: "primary wide" }, "Создать правило", -1 /* CACHED */))
    ], 32 /* NEED_HYDRATION */),
    _createElementVNode("div", _hoisted_16, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.rules, (rule) => {
        return (_openBlock(), _createElementBlock("div", {
          key: rule.id,
          class: "alert-rule-row"
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(["alert-rule-indicator", { inactive: !rule.active }])
          }, null, 2 /* CLASS */),
          _createElementVNode("div", null, [
            _createElementVNode("strong", null, _toDisplayString(rule.name), 1 /* TEXT */),
            _createElementVNode("small", null, _toDisplayString($setup.ruleSummary(rule)) + " · " + _toDisplayString(rule.integration_name) + " · " + _toDisplayString(rule.country || "все GEO"), 1 /* TEXT */),
            _createElementVNode("small", null, _toDisplayString(rule.user_name) + _toDisplayString(rule.telegram_configured ? "" : " · Telegram chat ID не задан"), 1 /* TEXT */)
          ]),
          _createElementVNode("button", {
            onClick: $event => ($setup.toggle(rule))
          }, _toDisplayString(rule.active ? "Отключить" : "Включить"), 9 /* TEXT, PROPS */, _hoisted_17),
          _createElementVNode("button", {
            class: "danger",
            onClick: $event => ($setup.remove(rule))
          }, "Удалить", 8 /* PROPS */, _hoisted_18)
        ]))
      }), 128 /* KEYED_FRAGMENT */)),
      (!$setup.rules.length)
        ? (_openBlock(), _createElementBlock("p", _hoisted_19, "Правил пока нет."))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}